// Interpreta la respuesta de los endpoints "read-document" (lector de
// documentos de energía, agua, combustibles, residuos, efluentes, emisiones
// y social).
//
// Antes cada API hacía `response.json()` directo: si el servidor o nginx
// cortaba el pedido (carga muy pesada → 413, demora → 504) devolvía una
// página HTML y el usuario veía "Unexpected token '<' ... is not valid JSON".
// Acá se traduce a un mensaje que explica qué hacer. Los formularios ya
// muestran `err.msg` en el toast, así que ninguno necesita cambios.
import enTranslations from "../translations/en.json";
import esTranslations from "../translations/es.json";
import frTranslations from "../translations/fr.json";
import ptTranslations from "../translations/pt.json";

const TRANSLATIONS = { en: enTranslations, es: esTranslations, fr: frTranslations, pt: ptTranslations };

const FALLBACK_MESSAGES = {
  read_document_too_large: "La carga es demasiado grande. Subí menos archivos a la vez (por ejemplo, de a un año o de a 2-3 PDFs escaneados).",
  read_document_timeout: "El documento tardó demasiado en procesarse. Probá subir menos archivos a la vez o PDFs con menos hojas.",
  read_document_server_error: "No se pudo procesar el documento en este momento. Volvé a intentar en unos minutos.",
};

// Fuera de React no hay contexto de idioma: se usa el mismo valor que guarda
// LanguageContext en localStorage.
function translate(key) {
  let language = "es";
  try { language = localStorage.getItem("appLanguage") || "es"; } catch (_) { /* sin storage */ }
  return (TRANSLATIONS[language] || TRANSLATIONS.es)[key] || FALLBACK_MESSAGES[key];
}

export async function readDocumentResponse(response) {
  const status = response.status;
  const body = await response.text();

  let result = null;
  try { result = JSON.parse(body); } catch (_) { /* HTML de nginx u otro error */ }

  if (status === 200 && result) return result;

  // 413: la carga supera el límite (nginx o el servidor). Se reemplaza el
  // mensaje del servidor ("El archivo supera…") porque el límite es del
  // envío completo, no de un archivo.
  if (status === 413) throw { code: 413, msg: translate("read_document_too_large") };
  if (status === 502 || status === 503 || status === 504) throw { code: status, msg: translate("read_document_timeout") };

  // Error del servidor con su propio mensaje (ej. 400 "No se recibió ningún
  // archivo", 429 "Demasiados documentos…"): se respeta tal cual.
  if (result) throw result;
  throw { code: status, msg: translate("read_document_server_error") };
}
